module.exports = __webpack_public_path__ + "media/images/durst_logo-ec2a39182a8ebce2a333a891dcc56214.svg";